import type { ComponentProps } from "react";

function classes(base: string, custom = "") {
  return `${base} ${custom}`.trim();
}

export function Card({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="card" className={classes("ui-card", className)} {...props} />;
}

export function CardHeader({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="card-header" className={classes("ui-card__header", className)} {...props} />;
}

export function CardTitle({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="card-title" className={classes("ui-card__title", className)} {...props} />;
}

export function CardDescription({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="card-description" className={classes("ui-card__description", className)} {...props} />;
}

export function CardContent({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="card-content" className={classes("ui-card__content", className)} {...props} />;
}

export function CardFooter({ className, ...props }: ComponentProps<"div">) {
  return <div data-slot="card-footer" className={classes("ui-card__footer", className)} {...props} />;
}
